<template>
  <draggable-modal ref="modal"
    @modalDismissed="modalDismissed"
    :width="400"
    :height="500"
    :minHeight="250"
    :minWidth="300"
    >
      <v-card
        class="mb-0"
        style="height: 100%;"
      >
        <v-card-text id="contentContainer">
          <v-card-title style="height: 75px; padding-top: 0; padding-right: 0;">
            <span class="headline">Chat</span>
            <v-spacer />
            <v-btn
              text
              class="ma-0 pa-0"
              @click="$refs.modal.hide(); modalDismissed();"
            >
              <v-icon x-large color="red">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <ChatList :messages="messages" style="max-height: 70vh;"/>
          <v-text-field
            v-model="inputText"
            @keydown.enter="addResponse"
            color="orange"
            class="ma-2"
            ref="chatTextInput"
            autocomplete="new"
            autofocus
            style="max-height: 50px;"
          />
        </v-card-text>
      </v-card>
  </draggable-modal>
</template>

<script>
import ChatList from './ChatList'

import { mapState, mapActions } from 'vuex'
import DraggableModal from './DragableModal.vue'

export default {
  name: 'Chat',

  props: ['chatMenuIsOpen'],

  components: {
    ChatList,
    DraggableModal
  },

  data: () => ({
    messages: [],
    inputText: ''

  }),

  async mounted () {
    this.messages = await this.getMessageInfoFromChats(this.chatLog)
  },

  computed: {
    ...mapState({
      chatLog: state => state.event.chatLog,
      userId: state => state.auth.userInfo.uuid
    })
  },

  watch: {
    async chatLog (chats) {
      this.messages = await this.getMessageInfoFromChats(chats)
    },

    chatMenuIsOpen (value) {
      // keeps the state of the chat modal synced with the modal
      if (value) {
        this.$refs.modal.show()
      } else {
        this.$refs.modal.hide()
      }
    }
  },

  methods: {
    ...mapActions(['requestChatHistory', 'sendChatMessage',
      'getAvatarFromUserName', 'requestSearchUserByUUID']),

    async getMessageInfoFromChats (chats) {
      const ret = []
      for (var chat of chats) {
        const sender = await this.requestSearchUserByUUID(chat.sender)
        var senderAvatar = await this.getAvatarFromUserName(sender.name)
        var message = {
          text: chat.payload,
          avatar: senderAvatar,
          source: chat.sender === this.userId ? 'self' : 'other',
          sender: chat.sender === this.userId ? 'you' : sender.name
        }
        ret.push(message)
      }
      return ret
    },

    addResponse (response) {
      if (this.inputText !== '') {
        this.sendChatMessage(this.inputText)
        this.inputText = ''
      }
    },

    modalDismissed () {
      // if we dismiss the modal by clicking off, then syync state
      this.$emit('toggleMenu')
    }
  }
}
</script>

<style lang="sass">
  .v-settings
    .v-item-group > *
      cursor: pointer

  .recieved
    margin: 0em 0em 1em 0em
  .sent
    margin: 0em 0em 1em 4em

  #contentContainer
    height: 100%
    display: flex
    flex-direction: column
    justify-content: flex-end
</style>
